// General
import "./basic-info.scss";
import { useEffect } from "react";
// Services
import { useLazyGetProfileQuery } from "../../../../../services/data.service";
// Static Data
import userConst from "../../../../../const/userConst";
import routeConst from "../../../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateVerifiedCallerDescriptionDialog,
  updateLgbtqDescriptionDialog,
} from "../../../../../redux/store/dialogStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import PlaceIcon from "@mui/icons-material/Place";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import useGetMembershipBadge from "../../../../utility/custom-hooks/useGetMembershipBadge-hook";
import IconManager from "../../../../utility/manager/icon-manager/icon-manager";
import useCustomNavigate from "../../../../utility/custom-hooks/useCustomNavigate-hook";
// Components
import VerifiedProfileBadge from "../../verified-profile-badge/verified-profile-badge";

const BasicInfo = () => {
  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();

  // Redux variables
  const idInt = useSelector((state) => state.userCard.idInt);
  const username = useSelector((state) => state.userCard.username);
  const age = useSelector((state) => state.userCard.age);
  const location = useSelector((state) => state.userCard.location);
  const membershipType = useSelector((state) => state.userCard.membershipType);
  const verifiedProfile = useSelector(
    (state) => state.userCard.verifiedProfile
  );
  const verifiedCaller = useSelector((state) => state.userCard.verifiedCaller);
  const specialBadges = useSelector((state) => state.userCard.specialBadges);
  const levellingBadge = useSelector((state) => state.userCard.levellingBadge);
  const livestreamingAchievementBadge = useSelector(
    (state) => state.userCard.livestreamingAchievementBadge
  );
  const isLgbtqInterested = useSelector(
    (state) => state.userCard.isLgbtqInterested
  );
  const isOnline = useSelector((state) => state.userCard.isOnline);
  const dispatch = useDispatch();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const getMembershipBadge = useGetMembershipBadge();
  const getIcon = IconManager();
  const onNavigate = useCustomNavigate();

  // Lifecycle | Mounted
  useEffect(() => {
    getProfile(null, true);
  }, []);

  // Event Handlers | Button
  const onOpenVerifiedCallerDialog = () => {
    dispatch(updateVerifiedCallerDescriptionDialog(true));
  };
  const onOpenLgbtqDialog = () => {
    dispatch(updateLgbtqDescriptionDialog(true));
  };
  const onNewTab = (url) => {
    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-30-30.15-Button",
      },
    });

    if (!url) return;

    window.open(url, "_blank");
    // if (
    //   (getProfileData?.data?.role === userConst.userRole.sugardaddy ||
    //     getProfileData?.data?.role === userConst.userRole.sugarmommy) &&
    //   getProfileData?.data?.membership_type === userConst.membershipType.free
    // ) {
    //   onNavigate(routeConst.upgrade.path);
    // } else {
    //   window.open(url, "_blank");
    // }
  };

  return (
    <div id="profile-view-basic-info-subcomponent">
      <div className="padding-container">
        <div className="info-container">
          {(livestreamingAchievementBadge?.length > 0 ||
            specialBadges?.length > 0) && (
            <div className="livestreaming-achievement-badge-container">
              {livestreamingAchievementBadge?.map((badge, index) => (
                <img
                  className="livestreaming-achievement-badge"
                  src={badge?.url}
                  alt={badge?.type}
                  key={index}
                />
              ))}

              {specialBadges?.map((badge, index) => (
                <img
                  className="special-badge"
                  src={badge?.asset}
                  alt={"special"}
                  onClick={() => onNewTab(badge?.url)}
                  key={index}
                />
              ))}
            </div>
          )}

          <div className="status-name-age-container">
            <div className="status-container">
              {isOnline && <div className="status"></div>}
            </div>
            <div className="name">{username || t("common.new_user")}</div>
            <div className="age">{age || "-"}</div>

            <div className="misc-container">
              {/* Verified Profile */}
              <div className="verified-profile-badge-container">
                <VerifiedProfileBadge
                  verifiedProfile={verifiedProfile}
                  className={"verified-profile-badge"}
                />
              </div>

              {/* Membership */}
              {(membershipType === userConst.membershipType.premium ||
                membershipType === userConst.membershipType.freePremium ||
                membershipType === userConst.membershipType.diamond) && (
                <div className="premium-badge-container">
                  <img
                    className="premium-badge"
                    src={getMembershipBadge(membershipType)}
                  />
                </div>
              )}

              {/* Verified Caller */}
              {verifiedCaller && (
                <div
                  className="verified-caller-badge-container"
                  onClick={onOpenVerifiedCallerDialog}
                >
                  {getIcon("verifiedCallerBadge", "verified-caller-badge")}
                </div>
              )}
            </div>
          </div>

          <div className="location-container">
            <div className="pin-icon-container">
              <PlaceIcon className="pin-icon" />
            </div>
            <div className="location">{location || "-"}</div>

            {/* Levelling */}
            {levellingBadge && (
              <div className="badge-container">
                <img className="badge" src={levellingBadge} />
              </div>
            )}

            {/* LGBTQ */}
            {isLgbtqInterested && (
              <div className="lgbtq-icon-container" onClick={onOpenLgbtqDialog}>
                {getIcon("lgbtqIcon", "lgbtq-icon")}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
